import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const GOAL_KEY_MAP = {
  'Buying': 'buying',
  'Selling': 'selling',
  'Selling my practice': 'selling_my_practice',
  'Selling part of my practice': 'selling_part_of_my_practice',
  'Find a Successor': 'find_a_successor',
  'Become a Successor': 'become_a_successor',
  'Merging': 'merging',
  'Partnering': 'partnering',
  'Forming a Partnership': 'forming_a_partnership',
  'Finding a Junior Partner': 'finding_a_junior_partner',
  'Becoming a Junior Partner': 'becoming_a_junior_partner',
  'Business Continuity': 'business_continuity',
  'Mentoring': 'mentoring',
  'Being Mentored': 'being_mentored',
  'Looking for Successor': 'looking_for_successor',
  'Currently not interested in Buying / Selling': 'currentlynotinterestedin_buying/selling',
};

const TransitionGoalsCard = ({ user }) => {
  const intl = useIntl();
  const goals = user.transition_goals || [];

  const translateGoal = (goal) => {
    const key = GOAL_KEY_MAP[goal];
    if (!key) return goal;
    const id = `transition_goals.${key}`;
    const msg = intl.formatMessage({ id, defaultMessage: goal });
    return msg;
  };
  const hasGoals = goals.length > 0;

  if (!hasGoals) {
    return null;
  }

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border p-6">
      {/* Header with icon */}
      <div className="flex items-start gap-4 mb-6">
        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 flex-shrink-0">
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </div>

        {/* Text */}
        <div className="flex-1">
          <h2 className="text-xl font-semibold text-succession-text-primary mb-1">
            {intl.formatMessage({ id: 'succession.profile_drawer.transition_goals.interested_in' })}
          </h2>
          <p className="text-sm text-succession-text-muted">
            {intl.formatMessage({ id: 'succession.profile_drawer.transition_goals.current_goals' })}
          </p>
        </div>
      </div>

      {/* Goals badges */}
      <div className="flex flex-wrap gap-3 mb-6">
        {goals.map((goal, index) => (
          <span
            key={index}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-gray-200 text-gray-800 text-sm font-medium"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" strokeWidth={2} />
              <circle cx="12" cy="12" r="3" fill="currentColor" />
            </svg>
            {translateGoal(goal)}
          </span>
        ))}
      </div>

      {/* Footer text */}
      <p className="text-sm text-succession-text-muted italic">
        {intl.formatMessage({ id: 'succession.profile_drawer.transition_goals.looking_to_connect' })}
      </p>
    </div>
  );
};

TransitionGoalsCard.propTypes = {
  user: PropTypes.shape({
    transition_goals: PropTypes.arrayOf(PropTypes.string),
    motivation: PropTypes.string,
  }).isRequired,
};

export default TransitionGoalsCard;

